export const PARTNERS = {
  Closeknit: {
    label: 'Closeknit',
    referrer_id: 'closeknit',
    referrer_name: 'closeknit',
    referral_source: 'src_closeknit',
    insurance_name: 'Carefirst Blue Cross Blue Shield',
  },
};
